<template>
  <div class="page">
    <!-- 头部 -->
    <Header></Header>
    <!-- 新闻列表 -->
    <div class="news">
      <div class="news_title">
        {{ newsDetail.topic }}
      </div>
      <div class="news_date">
        {{ newsDetail.createTime }}
      </div>
      <div class="line"></div>
      <div class="v-content" v-html="newsDetail.content"></div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import Header from "@/components/page/Header.vue";
import { getArticleDetail } from "@/api/app.js";
export default {
  components: {
    Footer,
    Header
  },
  data() {
    return {
      newsDetail: {},
    }
  },
  created() {
    this.id = this.$route.query && this.$route.query.id;
    this.getArticleDetail();
  },
  methods: {
    // 获取新闻详情
    getArticleDetail() {
      getArticleDetail({id: this.id}).then(res => {
        this.newsDetail = res
      });
    },
  },
}
</script>
<style scoped>
.page .news {
  margin-top: 150px;
}
.page .news .news_title {
  width: 584px;
  font-size: 36px;
  font-weight: 700;
  text-align: CENTER;
  color: #333333;
  margin: 0 auto;
  margin-top: 50px;
}
.page .news .news_date {
  width: auto;
  height: 27px;
  font-size: 24px;
  text-align: CENTER;
  color: #999999;
  margin: 0 auto;
  margin-top: 30px;
}
.page .news .line {
  width: 650px;
  height: 1px;
  background: #dddddd;
  margin: 0 auto;
  margin-top: 30px;
}
.page .news .v-content {
  padding: 30px;
  box-sizing: border-box;
  width: 100%;
}
.page .news .v-content /deep/ p {
  line-height: 45px;
  font-size: 24px;
  color: #666666;
  margin-bottom: 10px;
  text-align: justify;
}
.page .news .v-content h2 {
  display: block;
  color: #666666;
  line-height: 40px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.page .news .v-content /deep/ p img {
  display: block;
  width: 100%;
  margin: 30px auto;
}

</style>